import { reportsActionType } from '../../constants';

const reportsReducer = (state = [], action) => {
    switch (action.type) {
        case reportsActionType.FETCH_REPORTS:
            return action.payload;
        default:
            return state;
    }
};
export default reportsReducer